<template>
  <div class="row">
    <div class="col">
      <div class="input-container" v-click-outside="hidePopUp" >
        <input
          type="text"
          class="form-input EnterToTab"
          placeholder="HH:mm"
          @focus="showPopUp"
          readonly
          :value="value"
          :disabled="viewMode"
          enter-to-tab
        />
        <div v-if="isPopUpVisible" class="time-popup">
          <ul class="hour-container" ref="hour">
            <li
              v-for="(hour, index) in 24"
              :key="index"
              class="scroll-item"
              @click="onTimeSelected('hour', $event.target)"
            >
              {{ (hour - 1).toString().padStart(2, '0') }}
            </li>
          </ul>
          <ul class="minute-container" ref="minute">
            <li
              v-for="(minute, index) in 60"
              :key="index"
              class="scroll-item"
              @click="onTimeSelected('minute', $event.target)"
            >
              {{ (minute - 1).toString().padStart(2, '0') }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TimeQuestion',
  props: {
    viewMode: {
      type: Boolean,
      default: false
    },
    answerName: {
      type: String,
      default: '',
    },
    isRequired: {
      type: Boolean,
      default: false,
    }
  },
  data: function () {
    return {
      value: '',
      isPopUpVisible: false,
      previousSelectedMinute: null,
      previousSelectedHour: null,
    }
  },
  methods: {
    hidePopUp() {
      if (this.isPopUpVisible) {
        this.isPopUpVisible = false;
        
        this.$emit('onAnswered', this.value);
      }
    },
    async showPopUp() {
      this.isPopUpVisible = true;

      await this.$nextTick();

      // marck the hour and minute selected
      if (this.value) {
        const [hour, minute] = this.value.split(':');
        this.$refs.hour.childNodes[parseInt(hour)].classList.add('selected-item');
        this.$refs.minute.childNodes[parseInt(minute)].classList.add('selected-item');

        this.previousSelectedHour = this.$refs.hour.childNodes[parseInt(hour)];
        this.previousSelectedMinute = this.$refs.minute.childNodes[parseInt(minute)];
      }
    },
    onTimeSelected(type, target) {
      let [hourValue, minuteValue] = this.value.split(':');

      if (type === 'hour') {
        if (this.previousSelectedHour) {
          this.previousSelectedHour.classList.remove('selected-item');
        }

        this.previousSelectedHour = target;
        hourValue = target.innerHTML;
      }

      if (type === 'minute') {
        if(this.previousSelectedMinute) {
          this.previousSelectedMinute.classList.remove('selected-item');
        }

        this.previousSelectedMinute = target;
        minuteValue = target.innerHTML;
      }

      this.value = `${hourValue ?? '00'}:${minuteValue ?? '00'}`.replace(/ /g, '');

      target.classList.add('selected-item');
    },
  },
  watch: {
    answerName(newValue) {
      this.value = newValue || '';
      this.key = new Date().getTime();
    }
  },
  created() {
    this.value = this.answerName || '';
  }
}
</script>

<style scoped>
.input-container {
  width: 200px;
}

.form-input {
  padding: 0 12px;
  box-shadow: none;
  background-color: rgb(255, 255, 255);
  height: 40px;
  font-size: 0.875rem;
  line-height: 1.5rem;
  flex: 1 1 auto;
  border: 1px solid #4C4D57;
  border-radius: 0.25rem;
  color: #4C4D57;
  width: 100%;
}

.form-input:focus {
  box-shadow: rgb(0, 111, 255) 0 0 1px 2px;
  background-color: rgb(255, 255, 255);
  color: rgb(73, 80, 87);
  border-color: rgb(128, 189, 255);
  outline: 0;
}

.form-input[disabled] {
  color: #495057;
  background-color: #e9ecef;
}

.time-popup {
  margin-left: 15px;
  position: absolute;
  top: 40px;
  left: 0;
  width: 100%;
  height: 200px;
  background-color: white;
  z-index: 1;
  border: 1px solid #495057;
  border-radius: 0.2rem;
}

.hour-container::-webkit-scrollbar, .minute-container::-webkit-scrollbar {
  display: none;
}

.hour-container, .minute-container {
  padding: 0;
  margin: 0;
  display: inline-block;
  width: 50%;
  height: 100%;
  overflow-y: scroll;
}

.minute-container {
  border-left: 1px solid #495057;
}

.scroll-item {
  height: 20px;
  list-style: none;
  text-align: center;
}

.selected-item {
  background-color: #4F23C9;
  font-weight: bold;
  color: white;
}
</style>
